// Focuses the success message after a full-page post, for assistive technology.
document.addEventListener('DOMContentLoaded', function() {
  var success_messages = document.querySelectorAll('[data-newsletter-section-id]');
  success_messages.forEach(function(msg) {
    if (msg && msg.getAttribute('tabindex') === '-1') {
      setTimeout(function() {
        msg.focus();
      }, 100);
    }
  });
});

// Newsletter forms submit in place. Shopify answers a customer-form post with a
// redirect back to the page it came from, which reloads that page and, for the
// pop-up, reopens the modal to show the success message. Posting with fetch
// keeps the visitor where they are and swaps the message into the form. The
// pop-up drops its decline link once the message is up and closes itself a
// few seconds later; the footer form keeps its message in place.
//
// A form whose field wrapper carries data-klaviyo-list also subscribes the
// address to that Klaviyo list first, using the same public client endpoint
// Klaviyo's own sign-up forms post to. The company id is read from Klaviyo's
// onsite script tag, so the call only happens where that script is loaded.
//
// Anything the in-place path cannot handle (Shopify's spam challenge, a network
// failure, markup it does not recognize) falls back to a native submit.
(function() {
  // The snippet loads this file once per form on the page; bind the listener once.
  if (document.documentElement.hasAttribute('data-newsletter-bound')) return;
  document.documentElement.setAttribute('data-newsletter-bound', '');

  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var KLAVIYO_REVISION = '2026-07-15';
  var TIMEOUT_MS = 1500;
  var CLOSE_DELAY_MS = 3000;

  function klaviyoCompanyId() {
    var script = document.querySelector('script[src*="klaviyo.js"][src*="company_id="]');
    if (!script) return null;
    var match = script.getAttribute('src').match(/[?&]company_id=([^&]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function subscribeToKlaviyo(companyId, listId, email, source) {
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };
    return fetch(KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': KLAVIYO_REVISION },
      body: JSON.stringify(body),
      keepalive: true
    });
  }

  // Resolves once the Klaviyo call settles or the timeout passes; never rejects.
  function klaviyoFirst(form) {
    var marker = form.querySelector('[data-klaviyo-list]');
    var companyId = klaviyoCompanyId();
    var listId = marker ? marker.getAttribute('data-klaviyo-list') : null;
    var field = form.querySelector('input[name="contact[email]"]');
    var email = field ? field.value.trim() : '';
    if (!marker || !companyId || !listId || !email) return Promise.resolve();

    var source = (document.title || window.location.hostname) + ' newsletter form';
    return new Promise(function(resolve) {
      var done = false;
      var finish = function() {
        if (done) return;
        done = true;
        resolve();
      };
      setTimeout(finish, TIMEOUT_MS);
      try {
        subscribeToKlaviyo(companyId, listId, email, source).then(finish, finish);
      } catch (error) {
        finish();
      }
    });
  }

  function showSuccess(form) {
    var wrapper = form.querySelector('.newsletter-form__field-wrapper');
    var template = form.querySelector('template[data-newsletter-success]');
    if (!wrapper || !template || !template.content.firstElementChild) return false;

    var message = template.content.firstElementChild.cloneNode(true);
    wrapper.replaceChildren(message);
    message.focus();

    // The pop-up remembers the post so it does not open again this session,
    // loses its decline link, and closes itself once the message has been read.
    var modal = form.closest('newsletter-modal');
    if (modal) {
      if (modal.dataset.storageKey) {
        try {
          sessionStorage.setItem(modal.dataset.storageKey + '_submitted', true);
        } catch (error) {
          // Storage can be unavailable; the message is already on screen.
        }
      }
      var decline = modal.querySelector('.modal-decline');
      if (decline) decline.remove();
      setTimeout(function() {
        closeModal(modal);
      }, CLOSE_DELAY_MS);
    }
    return true;
  }

  // The theme's own close path drops the focus trap and the body scroll lock;
  // the close link is the fallback where that helper is not on the page.
  function closeModal(modal) {
    var helper = window.Woolman && window.Woolman.ModalsAndDrawers;
    if (helper && typeof helper.closeModalOrDrawer === 'function' && modal.id) {
      helper.closeModalOrDrawer(modal.id);
      return;
    }
    var closeLink = modal.querySelector('[data-modal-close]');
    if (closeLink) closeLink.click();
  }

  // Shopify re-renders the page with the form's error when the post fails
  // validation; the message for this form is lifted out of that page.
  function showError(form, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var remote = doc.getElementById(form.id);
    var message = remote ? remote.querySelector('.newsletter-form__message') : null;
    var wrapper = form.querySelector('.newsletter-form__field-wrapper');
    if (!message || !wrapper) return false;

    var existing = wrapper.querySelector('.newsletter-form__message');
    if (existing) existing.remove();
    wrapper.appendChild(message);

    var field = form.querySelector('input[name="contact[email]"]');
    if (field) {
      field.setAttribute('aria-invalid', 'true');
      field.focus();
    }
    return true;
  }

  // form.submit() does not raise a submit event, so this cannot loop back here.
  function nativeSubmit(form) {
    form.submit();
  }

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!form.matches || !form.matches('form.newsletter-form')) return;
    if (form.dataset.newsletterSubmitting === 'true') return;

    // Shopify's captcha bootstrap also listens for this submit, later in the
    // bubble phase, and answers it with a native form.submit() of its own,
    // which would leave the page. Stopping the event here keeps the post in
    // this handler; a submission Shopify does want to challenge comes back as
    // a redirect to its challenge page and takes the native path below.
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    form.dataset.newsletterSubmitting = 'true';
    var button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    var release = function() {
      form.dataset.newsletterSubmitting = '';
      if (button) button.disabled = false;
    };

    klaviyoFirst(form).then(function() {
      return fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'text/html' },
        credentials: 'same-origin',
        redirect: 'follow'
      });
    }).then(function(response) {
      var url = response.url || '';
      if (url.indexOf('/challenge') !== -1) {
        nativeSubmit(form);
        return;
      }
      if (response.ok && url.indexOf('customer_posted=true') !== -1) {
        if (!showSuccess(form)) nativeSubmit(form);
        return;
      }
      return response.text().then(function(html) {
        release();
        if (!showError(form, html)) nativeSubmit(form);
      });
    }).catch(function() {
      nativeSubmit(form);
    });
  }, true);
})();
